<div class="edit-page">
  <div class="visitor">
    <button class="close" (click)="close()">
      <img class="cross-icon" src="icons/profile-close.svg" />
    </button>
    <span class="visitor-txt">Edit Aadhaar</span>
  </div>

  <p class="form-header">
    Update Aadhaar number
  </p>

  <input
    type="text"
    maxlength="12"
    class="text-box-active"
    [(ngModel)]="aadhaar"
  />

  @if(errorMessage !== '' && data.editType !== 'Visitor'){
  <div class="error">
    <span class="err-message">{{errorMessage}}</span>

    <div class="err-content">
      <div class="err-detail">

        <span class="detail-title">Name:</span> 
        <span class="detail-txt">{{errData.name}}</span>
      </div>
       <div class="err-detail">

        <span class="detail-title">Contact:</span> 
        <span class="detail-txt">{{errData.contactNumber}}</span>
      </div>
       <div class="err-detail">

        <span class="detail-title">FamilyCode:</span> 
        <span class="detail-txt copy-fc" (click)="copy(errData.familyCode)" title="Click to copy">{{errData.familyCode}}</span>
      </div>
    </div>
  </div>
}

  <div class="action-row">
    <button class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button class="primary-btn" (click)="continue()">Save</button>
  </div>
</div>
